import React from "react";
import { Home } from "../screens";

const publicRoutes = [
  { path: "/", element: <Home /> },
//   { path: "/forgot", element: <ForgotPassword /> },
];

export default publicRoutes;